import { z } from "zod";
import { LocaleSchema, TimestampSchema } from "./common.js";
import { IdSchema } from "./ids.js";
export const UserSchema = z.object({
    id: IdSchema,
    email: z.email(),
    displayName: z.string().min(1),
    locale: LocaleSchema,
    /** Owners are a set (at least one, all with the same authority); set only by the CLI or an Owner. */
    isOwner: z.boolean(),
    /** The user must set a new password before anything else (temporary password at creation). */
    mustChangePassword: z.boolean().optional(),
    status: z.enum(["invited", "active", "disabled"]),
    createdAt: TimestampSchema,
});
export const InviteSchema = z.object({
    id: IdSchema,
    email: z.email(),
    invitedBy: IdSchema,
    /** The invitee must acknowledge that the Owner can see everything (DESIGN §10). */
    disclosureAcceptedAt: TimestampSchema.nullable(),
    expiresAt: TimestampSchema,
    acceptedAt: TimestampSchema.nullable(),
});
/** The verified caller of a request. */
export const AuthContextSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("user"),
        userId: IdSchema,
        sessionId: IdSchema,
        locale: LocaleSchema,
        isOwner: z.boolean(),
        /** The user must change the password first; every route but change-password and sign-out refuses. */
        mustChangePassword: z.boolean().optional(),
        /** True when this session completed a second factor. */
        mfaVerified: z.boolean(),
        expiresAt: TimestampSchema,
    }),
    z.object({
        kind: z.literal("service"),
        /** e.g. "gateway", "company-node:<companyId>". */
        serviceId: z.string().min(1),
        companyId: IdSchema.nullable(),
        expiresAt: TimestampSchema,
    }),
]);
//# sourceMappingURL=identity.js.map